<section class="signup-form">
  <form fxLayout ="column" fxLayoutAlign ="center center" fxLayoutGap= "10px" #f="ngForm" (ngSubmit) ="onSubmit(f)">
    
      <mat-form-field>
        <input type="email" matInput placeholder="Your email" ngModel name="email" email required
               #emailInput ="ngModel"/>
        <mat-error *ngIf ="emailInput.hasError('required')">Email cannot be empty</mat-error>
        <mat-error *ngIf ="!emailInput.hasError('required')">Email is invalid</mat-error>
      </mat-form-field>
  
    
      <mat-form-field hintLabel="Should be atleast 6 characters long">
        <input type="password" matInput placeholder="Your Password" ngModel name="password" required  minlength ="6"
               #pwInput ="ngModel"/>
        <mat-hint align="end">{{pwInput.value?.length}} / 6</mat-hint>
      </mat-form-field>
     
     <button type="submit" mat-raised-button color="primary" [disabled]="f.invalid">Submit</button>
  </form>
</section>
